<template>
    <li class="list-group-item list-group-item-action px-2">   
      <div class="d-flex">
        <slot name="initial"></slot>    
        <div class="d-flex w-100 align-items-center justify-content-between">           
          <slot name="title"></slot>
          <slot name="info"></slot>
        </div>
      </div>                  
      <slot name="complement"></slot>                         
    </li>
</template>

<script>
export default {
    name:"ListItem"
}
</script>

<style lang="css" scoped>
  @import"../../assets/css/_colors";
</style>

